import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'helpers/CSSModulesUtil'
import { Snackbar } from 'react-toolbox/lib/snackbar'
import cn from 'classnames'

import {
  NOTIFICATION
} from './constants'

import Message from './Message'

import styles from './styles.scss'

const NotificationSnackbar = ({type, ...props}) => {
  const classes = cn(styles[type])
  return (
    <Snackbar
      {...props}
      class={classes}
      theme={styles}
    >
      <Message {...props} type={type}/>
    </Snackbar>
  )
}

NotificationSnackbar.propTypes = {
  type: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
}

NotificationSnackbar.defaultProps = {
  type: NOTIFICATION.INFO.value,
  active: false,
}

const withStyle = CSSModules(styles)
export default withStyle(NotificationSnackbar)
